import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from "react-router-dom";
import {Footer, Header} from "components";
import Navbar from "./NavBar";
import {BASE_URL, DISABILITY, DYSLEXIA} from "../constants";
import {backImg} from "../images/";
import axios from "axios";
import {logout} from "../store/actions";

export const IzjavaPristupacnosti = () => {
    const navigate = useNavigate(); // Hook za navigaciju
    const dispatch = useDispatch(); // Hook za dispatcanje akcija
    const [dokumenti, setDokumenti] = useState([]); // Stanje za pohranu dokumenata
    const [isLoading, setIsLoading] = useState(true); // Indikator učitavanja
    const userData = useSelector(state => state.authentication.userData);
    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);
    const subjectData = useSelector(state => state.authentication.subjectData);

    // Preusmjeravanje na odjavljivanje
    const handleLogout = () => {
        console.log("loging out");
        dispatch(logout(()=> navigate('/logedout')))
    }
    // URL za odjavu
    const constructLogoutUrl = useMemo(() => {
        return `${BASE_URL}/nias/application/logout`;
    }, []);

    // Preusmjeravanje na  dashboard
    const handleNavigation = () => navigate("/dash");

    // Rukovanje slabovidnošću
    const handleVisionImapired = (isImpaired) => {
        dispatch({
            type: DISABILITY,
            payload: isImpaired,
        });
    };
    // Rukovanje disleksijom
    const handleDyslexia = (isDyslexic) => {
        dispatch({
            type:DYSLEXIA,
            payload: isDyslexic,
        })
    };

    // Učitavanje dokumenata izjave o pristupačnosti
    useEffect(() => { // Hook koji se poziva nakon što se komponenta renderira
        const params = {
            vrstaDok: 1, // Vrsta dokumenta - 1 predstavlja Izjavu o pristupačnosti
            jezik: "hr", // Jezik
            idServisa: 0 // ID servisa 0 predstavlja Portal e-Pristojbe (hibridna)
        };
        // Poziv REST servisa za dohvat dokumenata izjave o pristupačnosti
        axios
            .get(`${BASE_URL}/html-dokument`, {params})// BASE_URL je globalna varijabla koja sadrži URL aplikacije (http://localhost:8080)
            .then((response) => {
                setDokumenti(response.data); // Postavi podatke
            })
            .catch((error) => {
                console.error("Greška prilikom dohvaćanja dokumenata izjave o pristupačnosti: ", error);
            })
            .finally(() => {
                setIsLoading(false); // Zaustavi prikaz učitavanja
            });
    }, []); // Prazan array [] znači da se useEffect poziva samo jednom nakon renderiranja



    // vrati izjavu o pristupačnosti zajedno sa navigacijskom trakom nakon prijave
    return (
        <>
            <div className="accessibility-grid-container">
                <div>
                    <Navbar
                        messageId={userData?.inResponseTo}
                        navToken= {userData?.navToken}
                        logoutUrl= {constructLogoutUrl}
                        loginUrl={`${BASE_URL}/nias`}
                        isAuthenticated = {isAuthenticated}
                        logout={handleLogout}
                        forLegalIps={subjectData?.forLegalIps}
                        forLegalIzvor={subjectData?.forLegalIzvor}
                        forPersonOib={subjectData?.forPersonOib}
                        toLegalIps={subjectData?.toLegalIps}
                        toLegalIzvor={subjectData?.toLegalIzvor}
                        handleVisionImpaired={handleVisionImapired}
                        handleDyslexia={handleDyslexia}
                        test
                    />
                    <Header/>
                </div>
                <div className="wrapper">
                    <div className="main-content">
                        <div className="welcomeText text-impaired">
                            <div className="statementWrapper">
                                { isLoading ?
                                    (
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Učitavam izjavu ...</span>
                                        </div>
                                    )
                                    :
                                    (
                                        <div>
                                            {dokumenti.length === 0 ? (
                                                <p>Izjava o pristupačnosti nije pronađena!</p>
                                            ) : (
                                                <div dangerouslySetInnerHTML={{__html: dokumenti[0]}}/>
                                            )}
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        <div className="backBtnWrapper">
                            <button onClick={handleNavigation} className="backBtn">
                                <img alt="Povratak na prijavu" className="backBtnImg" src={`${backImg}`}/>
                                Povratak na prijavu
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <Footer/>
                </div>
            </div>
        </>
    );
};
